(() => {
  if (window.__avonticWorkforcePathways) return;
  window.__avonticWorkforcePathways = true;

  const trackedImpressions = new WeakSet();
  let observer;

  const track = (name, payload) => {
    try {
      window.AvonticAnalytics?.track?.(name, payload);
    } catch (_) {
      // Revenue-path analytics must never interrupt navigation.
    }
  };

  const surfaceFor = (element) => (
    element?.dataset?.workforceSurface
    || element?.closest?.('[data-workforce-surface]')?.dataset?.workforceSurface
    || 'unknown'
  );

  const observe = (root = document) => {
    if (!('IntersectionObserver' in window)) return;
    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.35 || trackedImpressions.has(entry.target)) return;
          trackedImpressions.add(entry.target);
          track('av_workforce_pathway_view', {
            component: 'workforce_pathway',
            surface: surfaceFor(entry.target),
            position: Number(entry.target.dataset.workforcePosition) || undefined,
            visibility_ratio: Math.round(entry.intersectionRatio * 100) / 100
          });
          observer.unobserve(entry.target);
        });
      }, { threshold: [0.35] });
    }

    root.querySelectorAll?.('[data-av-workforce-impression]').forEach((element) => {
      if (!trackedImpressions.has(element)) observer.observe(element);
    });
  };

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element
      ? event.target.closest('[data-av-workforce-link]')
      : null;
    if (!link) return;

    track('av_workforce_pathway_click', {
      component: 'workforce_pathway',
      surface: surfaceFor(link),
      position: Number(link.dataset.workforcePosition) || undefined,
      destination: link.href,
      action: link.dataset.workforceAction || 'open_collection'
    });

    document.dispatchEvent(new CustomEvent('avontic:workforce-pathway-click', {
      detail: {
        surface: surfaceFor(link),
        destination: link.href,
        action: link.dataset.workforceAction || 'open_collection'
      }
    }));
  });

  document.addEventListener('DOMContentLoaded', () => observe());
  document.addEventListener('shopify:section:load', (event) => observe(event.target));
  if (document.readyState !== 'loading') observe();
})();
